import { throttle } from './index';


class ScrollDepth {
  constructor() {
    this.startTime = +new Date;
    this.cache = [];
    this.documentElement = document.documentElement;
    this.lastPixelDepth = 0;
    this.pathname = '';

    this.handleScroll = this.handleScroll.bind(this);
  }

  init() {
    this.bindEventListeners();
  }

  bindEventListeners() {
    const throttledHandleScroll = throttle(this.handleScroll, 500);
    window.addEventListener('scroll', throttledHandleScroll, false);
  }

  calculateMarks(docHeight) {
    return {
      '25': parseInt(docHeight * 0.25, 10),
      '50': parseInt(docHeight * 0.50, 10),
      '75': parseInt(docHeight * 0.75, 10),
      '100': docHeight - 5
    }
  }

  checkMarks(marks, scrollDistance, timing) {
    for (let key in marks) {
      if (this.cache.indexOf(key) === -1 && scrollDistance >= marks[key]) {
        this.sendEvent(parseInt(key, 10));
        this.cache.push(key);
      }
    }
  }

  getDocumentHeight() {
    return Math.max(
      document.body.scrollHeight || 0, this.documentElement.scrollHeight || 0,
      document.body.offsetHeight || 0, this.documentElement.offsetHeight || 0,
      document.body.clientHeight || 0, this.documentElement.clientHeight || 0,
    );
  }

  getWindowHeight() {
    return window.innerHeight || this.documentElement.clientHeight || document.body.clientHeight || 0;
  }

  getScrollDistance() {
    return window.pageYOffset || document.body.scrollTop || this.documentElement.scrollTop || 0;
  }

  sendEvent(action) {
    if (typeof dataLayer !== 'undefined' && typeof dataLayer.push === 'function') {
      window.dataLayer.push({
        'event': 'ScrollDepth',
        'event_category': 'Engagement',
        'event_action': action,
        'event_label': this.pathname
      });
    }
  }

  reset() {
    this.cache = [];
  }

  setPath(path) {
    this.pathname = path;
  }

  handleScroll() {
    const docHeight = this.getDocumentHeight(),
          winHeight = this.getWindowHeight(),
          scrollDistance = this.getScrollDistance() + winHeight,
          marks = this.calculateMarks(docHeight),
          timing = +new Date - this.startTime;

    if (this.cache.length >= 4) {
      return;
    }

    this.checkMarks(marks, scrollDistance, timing);
  }
}

export default ScrollDepth;